import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Category, Dashboard } from '../services/DashboardsService';
import DashboardForm from './DashboardForm';

interface DashboardCreateDialogProps {
  category: Category | null;
  categories: Category[];
  dashboardsByCategory: { [categoryId: string]: Dashboard[] };
  open: boolean;
  onClose: () => void;
  onSave: (dashboard: Dashboard) => Promise<boolean>;
}

/**
 * Dialog component for creating a new dashboard
 */
const DashboardCreateDialog: React.FC<DashboardCreateDialogProps> = ({
  category,
  categories,
  dashboardsByCategory,
  open,
  onClose,
  onSave
}) => {
  if (!category) return null;

  // Create initial values for new dashboard
  const initialValues: Dashboard = {
    id: 0,
    name: '',
    shortName: '',
    type: 'superset',
    orderBy: 1,
    category: category,
    resource: '',
    embedId: '',
    accessOnly: false,
    internalOnly: false,
    listenReporting: false,
    hxcProgram: false,
    placeholder: false,
    deactivated: false,
    subtitle: '',
    demo: '',
    downtime: '',
    icon: '',
    superscript: '',
    thumbnail: '',
    updateDate: new Date().toISOString()
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="create-dashboard-dialog-title"
    >
      <DialogTitle id="create-dashboard-dialog-title" sx={{ pr: 8 }}>
        Create New Dashboard
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent dividers>
        <DashboardForm
          initialValues={initialValues}
          categories={categories}
          dashboardsByCategory={dashboardsByCategory}
          onSave={onSave}
          onCancel={onClose}
          isNew={true}
        />
      </DialogContent>
      
      <DialogActions>
        {/* Form already has its own action buttons */}
      </DialogActions>
    </Dialog>
  );
};

export default DashboardCreateDialog;